import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import RulesTab from "../components/admin/RulesTab";
import ThresholdsTab from "../components/admin/ThresholdsTab";
import PhrasesTab from "../components/admin/PhrasesTab";
import AuditTab from "../components/admin/AuditTab";

export default function AdminPage() {
  return (
    <div className="p-8" data-testid="admin-page">
      <h1 className="text-2xl font-semibold tracking-tight">Pengaturan Sistem</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-6">
        Kelola kriteria scoring. Perubahan langsung digunakan mesin scoring untuk klaim baru berikutnya.
      </p>
      <Tabs defaultValue="rules">
        <TabsList className="rounded-none h-10">
          <TabsTrigger data-testid="admin-tab-rules" value="rules" className="rounded-none">Aturan Scoring</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-thresholds" value="thresholds" className="rounded-none">Threshold Risiko</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-phrases" value="phrases" className="rounded-none">Phrase Dictionary</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-audit" value="audit" className="rounded-none">Audit Log</TabsTrigger>
        </TabsList>
        <TabsContent value="rules" className="mt-4"><RulesTab /></TabsContent>
        <TabsContent value="thresholds" className="mt-4"><ThresholdsTab /></TabsContent>
        <TabsContent value="phrases" className="mt-4"><PhrasesTab /></TabsContent>
        <TabsContent value="audit" className="mt-4"><AuditTab /></TabsContent>
      </Tabs>
    </div>
  );
}
